"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SafeParseJsonError = void 0;
exports.safeParseJson = safeParseJson;
var _error = require("@ori/error");
var _constants = require("../constants");
const SafeParseJsonError = exports.SafeParseJsonError = (0, _error.createCustomError)('SafeParseJsonError', {
  JSON_NOT_PROVIDED: _constants.JSON_NOT_PROVIDED,
  JSON_NOT_VALID: `${_constants.JSON_NOT_VALID}
  {0}: {1}
  {2}
  `
});

/**
 * Safely converts a JSON string into an object.
 * Throws error if providen string is empty (error: JSON_NOT_PROVIDED) or contains invalid JSON (error: JSON_NOT_VALID).
 * @param jsonString A JSON string.
 * @returns Converted a JSON string into an object.
 */
function safeParseJson(jsonString) {
  if (!jsonString) {
    throw new SafeParseJsonError('JSON_NOT_PROVIDED');
  }
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    const {
      name,
      message
    } = error;
    throw new SafeParseJsonError('JSON_NOT_VALID', {
      messageParameters: [name, message, jsonString]
    });
  }
}
//# sourceMappingURL=safeParseJson.js.map